"use client";

import type { ReactNode } from "react";
import dynamic from "next/dynamic";
import MapIllustration from "@/guide/MapIllustration";

const MapWrapper = dynamic(() => import("@/components/ui/MapWrapper"), {
  ssr: false,
});

export interface ListingMapItem {
  kind: "pin" | "area";
  lat: number;
  lng: number;
  radius?: number;
  popover?: ReactNode;
}

/** Pins for Fuld visning and circles for Kun område, never closer than zoom 14; the anonymous levels have no place on
 *  it. The guide and the CMS preview, which never contact the map service, draw the map illustration. */
export default function ListingsMap({
  items,
  label,
  illustration,
}: {
  items: ListingMapItem[];
  /** what the map shows, read before it: »Kort: …« */
  label: string;
  illustration: boolean;
}) {
  return (
    <div
      className="pf-ml-map-frame"
      role="region"
      aria-label={`Kort: ${label}`}
    >
      {illustration ? (
        <MapIllustration
          markerLabel={label}
          caption="Kortet viser boligernes placering eller område."
        />
      ) : (
        <MapWrapper
          maxZoom={14}
          markers={items
            .filter((item) => item.kind === "pin")
            .map((item) => ({
              latitude: item.lat,
              longitude: item.lng,
              zoom: 14,
              popover: item.popover,
            }))}
          areas={items
            .filter((item) => item.kind === "area")
            .map((item) => ({
              latitude: item.lat,
              longitude: item.lng,
              radius: item.radius ?? 1000,
              popover: item.popover,
            }))}
        />
      )}
    </div>
  );
}
